import { useTranslation } from "react-i18next";

import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IVehicle, VehicleComplexity } from "../../models/Vehicle";

export default function VehicleComplexityDropdown({ vehicle, classes = "" }: { vehicle: IVehicle, classes?: string }) {
  const { t } = useTranslation("vehicles");
  const { patchVehicle } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers(t("Vehicle Complexity"));

  const handleComplexityUpdate = (complexity: string) => {
    patchVehicle.mutate(
      { vehicleId: vehicle.id, patch: { complexity: parseInt(complexity) } },
      {
        onSuccess: () => saveHandlers.onSuccess(),
        onError: () => saveHandlers.onError(),
      }
    );
  };

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      <select value={vehicle.complexity} className={`${classes} border border-gray-300 p-1`} onChange={(e) => handleComplexityUpdate(e.target.value)}>
        {Object.values(VehicleComplexity).filter((ct) => isNaN(Number(ct))).map((complexity, i) => (
          <option key={complexity} value={i}>
            {t(String(complexity))}
          </option>
        ))}
      </select>
    </div>
  );
}
